export default __webpack_public_path__ + "static/grill-7e7da3c45f58df6888c6f5c731be99e6.svg";